/* eslint-disable max-len */
// /* eslint-disable security/detect-object-injection */
// /* eslint-disable max-len */
import React, { Fragment, useCallback, useRef } from 'react'
import InputBox from '../../CommonMethods/InputBox'
import ErrorMessage from '../../components/ErrorMessage'
import TextArea from '../../components/TextArea'
import TopHeader from '../../components/TopHeader'
import { useState, useContext, useEffect } from 'react'
import { useNavigate, useParams, useLocation } from 'react-router-dom'
import { useSelector, useDispatch } from 'react-redux'
import { dataService } from '../../services/data.services'
import GlobalContext from '../../components/Context/GloablContext'
import { Link } from 'react-router-dom'
import { validateEmail } from '../../CommonMethods/EmailValidator'
import CustomOverLay from '../../components/CustomOverLay'
import { motion } from 'framer-motion'
import AnimatedModel from '../../components/Animation/AnimatedModel'
import Loader from '../../components/Loader'
import Debounce from '../../CommonMethods/Debounce'
import { useGetSubDivQuery } from '../../slices/apiSlice'
import ConfirmationPrompt from '../../components/ConfirmationPrompt'
import SearchEmptyScreen from '../../components/SearchEmptyScreen'
// import { useLazyGetMonitorAssociatedOrganizationsQuery, useLazyGetMonitorSubdivisionsQuery } from '../../features/manageMonitorSlice'
import PhoneNumberValidator from '../../components/PhoneNumberInput'
// import ProviderOrganizationAssocaition from '../ManageProvider/Components/ProviderOrganizationAssocaition'
import { useAddObserverMutation, useEditObserverMutation, useViewObserverQuery,useLazyViewObserverQuery } from '../../slices/observerSlice'
import { useLazyGetOrgUserSubdivisionsQuery, useUpdateEmailMutation } from '../../slices/apiSlice'
import PatientDropdownWithSearch from './Components/PatientDropdown'
import { useLazyGetObsPatientSubdivisionsQuery } from '../../slices/observerSlice'
import { useLinkPatienttoObserverMutation, useDeletePatientAssociatedObserverMutation } from '../../slices/observerSlice'
import Emptyscreenwithouttitle from '../../components/Emptyscreenwithouttitle'
import { useLazyGetPatientQuery } from '../../slices/patientSlice'
import SubdivisionDropdownWithSearch from '../ManagePatient/AddPatient/Components/subdivisionwithsearchwithoutcheckbox'
import { handleEditMessageSent,handleSystemConfig,handleTargetUserEditId } from '../../redux/systemConfigSlice'
import { userService } from '../../services/user.services'
import HelpGuideModal from '../../components/HelpGuideModal'
import {useGetHelpGuideOrganizationQuery} from '../../slices/patientSlice'

export default function AddObserverDetails({ edit }) {
    const location = useLocation()
    // Listing state (search/filters/pagination) carried in from the listing, so every
    // exit path below can hand it back instead of dropping the user's filter.
    const originalListingState = Array.isArray(location.state) ? '' : (location.state ?? '')

    const [addObserverDetails] = useAddObserverMutation()
    const [editObserver] = useEditObserverMutation()
    const [deleteLoading, setdeleteLoading] = useState(false)
    const [countryCodes, setCountryCodes] = useState([])
    const [isOpen, setisOpen] = useState(false);
    const [isOpensub, setisOpensub] = useState(false);
    const [profileDetails, setProfileDetails] = useState({});
    const [initialLoader, setInitialLoader] = useState(true);
    const [isColumnSelect, setIsColumnSelect] = useState(false);
    const [deleteModel, setDeleteModel] = useState(false);
    const [linkOrganizationModel, setLinkOrganizationModel] = useState(false);
    const [payload, setpayload] = useState({});
    const [isOpenLimit, setIsOpenLimit] = useState(false);
    const [linkPatienttoObserver] = useLinkPatienttoObserverMutation()
    const [deletePatientAssociatedObserver] = useDeletePatientAssociatedObserverMutation()
    const [organizationListSearch, setOrganizationListSearch] = useState({ search: '' });
    const [selectedOrganizationName, setSelectedOrganizationName] = useState({
        organization_name: '',
        organization_id: '',
    });
    const [emailButtonLoading, setEmailButtonLoading] = useState(false)
    const [emailVefiedButton, setEmailVeriedButton] = useState(true);
    const [queryParams, setQueryParams] = useState(``, { refetchOnMountOrArgChange: true })
    const [queryParamsOrg, setQueryParamsOrg] = useState('dropdown=true')
    const { id } = useParams()
    let { data: suddivisonData, isFetching: sudDivisionIsFetching, isLoading, status: subdivisionStatus } = useGetSubDivQuery(queryParams)
    // updtae email
    const [updateEmail] = useUpdateEmailMutation()
    const [selectedSubdivisionName, setSelectedSubdivisionName] = useState('')
    const [selectedSubdivisionId, setSelectedSubdivisionId] = useState('')
    const [confirmationStateStatus, setConfirmationStateStatus] = useState(false)
    const [patientListSearch, setPatientListSearch] = useState({ search: '' });
    const [selectedPatient, setSelectedPatient] = useState({
        patient_id: '',
        patient_object_id: '',
        patient_first_name: '',
        patient_middle_name: '',
        patient_last_name: ''
    })
    const messageSent=useSelector(state=>state?.systemConfigData?.messageSent)
    const [dataloading,setDataLoading] = useState(true)
    const [trigger,result] = useLazyViewObserverQuery()
    const [helpGuideModel, setHelpGuideModel] = useState(false);
    const [triggerApiCall, setTriggerApiCall] = useState(false);
    const [queryParamsorg, setQueryParamsorg] = useState('')
    const userType = sessionStorage.getItem('user_type')
      
    const { data: helpguidedata, status: helpguidestatus } = useGetHelpGuideOrganizationQuery(queryParamsorg, {
        skip: !triggerApiCall,  // Skip the query until the trigger is set to true
    });
    
    // fetch country code
    const fetchCountryCodes = async () => {
        const res = await dataService.getCountryCodes();
        // const extractedValues = res.data.map((country) => country.callingCodes[0]+'\t'+'-'+'\t'+'('+country.name+')');
        let uniqueValues = [...new Set(res?.data?.map((country) => country?.callingCodes[0] + '\t' + '-' + '\t' + '(' + country?.alpha3Code + ')'))];
        setCountryCodes(uniqueValues)
    }

    useEffect(() => {
        setAddObserver((prev) => ({
            ...prev,
            country_code: `+ ${(country_code ? country_code.match(/\d+/)?.[0] || "" : "")}`
        }));
        fetchCountryCodes()
    }, [])
    // const { data: organizationData, isFetching: organizationFetching } = useGetOrganizationsQuery(
    //     queryParamsOrg,  { refetchOnMountOrArgChange: true }
    // );

    const [searchParams, setSearchParams] = useState(`${id}?page_number=1&limit=15`);

    const [subTrigger, subresult, lastPromiseinfo1] = useLazyGetOrgUserSubdivisionsQuery();
    const [patientTrigger, patientRes] = useLazyGetObsPatientSubdivisionsQuery()
    const [patientDetailsTrigger, patientDetailsRes] = useLazyGetPatientQuery()

    const [addObserver, setAddObserver] = useState({
        "user_name": "",
        "first_name": "",
        "last_name": "",
        "mobile_number": "",
        "main_number": "",
        "address": "",
        "email_addr": "",
        "monitor_permission": true,
    })

    const [isDisableCancel, setIsdisableCancel] = useState(true)
    const userArr = useSelector(state => state.userSelect.selectedUsers.checkedArr)
    const [skip, setSkip] = useState(true)
    const [confirmationState, setConfirmationState] = useState(false)
    const [confirmationStateCancel, setConfirmationStateCancel] = useState(false)
    const { setToastmessage, setToastErrorMessage, isSideBar,editSocket,setEditSocket,sendMessageToStopEditing,sendMessageToStartEditing } = useContext(GlobalContext)
    const [emptyField, setEmptyField] = useState(false)
    const [emailError, setEmailError] = useState({
        "email_error": false,
        "username_error": false
    })
    const [isOpenPatient, setIsOpenPatient] = useState(false)
    const [isPhoneNumberValid, setIsPhoneNumberValid] = useState({ "mobile_number": true, "main_number": true });
    const [statusToggle, setStatusToggle] = useState(false)

    // Alert preferences state
    const [observerSmsAlert, setObserverSmsAlert] = useState(false)
    const [observerEmailAlert, setObserverEmailAlert] = useState(false)
    const [observerMissedReading, setObserverMissedReading] = useState(false)
    const [observerReadingReceived, setObserverReadingReceived] = useState(false)

    const [loading, setLoading] = useState(false)
    const navigate = useNavigate()
    const country_code = useSelector((state) => state?.systemConfigData?.globalVariables?.country_code?.split("-")[0])
    const countryCodeList = useSelector((state) => state?.systemConfigData?.countryCodes)
    const dateformat = useSelector(state => state.systemConfigData.globalVariables.date_format)
    const [countryCodeVal, setCountryCodeVal] = useState('')
    const [countryCodeVal2, setCountryCodeVal2] = useState('')
    const [emptyArea, setEmptyArea] = useState(false);
    const [usernameError, setUsernameError] = useState(false)
    const [loadingStatus, setLoadingStatus] = useState(false)
    const [textAreaMsg, setTextAreaMsg] = useState('')
    const [submitSelected, setSubmitSelected] = useState(false);
    const { data, isFetching, status } = useViewObserverQuery(id, { skip: skip })
    const [nextTarget, setNextTarget] = useState('');
    const userIDRef = useRef(null);
    const editingUserId = useSelector(state=>state?.systemConfigData?.editingUserId)
        

    const handleChangePatient = (value, id) => {
        if (value.trim() !== '') {
            patientTrigger(`subdivision_id=${id}&search=${encodeURIComponent(value)}`)

        } else {
            patientTrigger(`subdivision_id=${id}`)
        }
    }

    const handlePatientSearchTrigger = useCallback(
        Debounce((value, id) => handleChangePatient(value, id)), []
    )
    //  handle patient search
    const handlePatientListSearch = (value) => {
        setPatientListSearch({ search: value })
        handlePatientSearchTrigger(value, selectedSubdivisionId)

    };

    const handleSelectionSubdivision = (item) => {
        setIsdisableCancel(false)
        setSelectedSubdivisionName(item)
        setSelectedSubdivisionId(item.subdivision_id)
        patientTrigger(`subdivision_id=${item.subdivision_id}`)
        setpayload(item)
        setisOpensub(false);
    }

    const dispatch = useDispatch()

    function handleOnChangeUserDetails(id, option) {
        setIsdisableCancel(false)
        setSubmitSelected(false)

        setEmptyField(false)
        setEmailError({
            email_error: false,
            username_error: false
        })
        const fieldToUpdate = {
            user_name: "user_name",
            first_name: "first_name",
            last_name: "last_name",
            mobile_number: "mobile_number",
            main_number: "main_number",
            address: "address",
            email_addr: 'email_addr',
        }[id];
        const regex = /^[1-9]\d*$/;
        let sanitizedOption = option;
        let isValid = true

        if (id === "mobile_number" || id === "main_number") {
            sanitizedOption = sanitizedOption.replace(/\D/g, "");
            if (!regex.test(option)) {
                isValid = false
            }
        }
        if (!isValid) {
            if (fieldToUpdate) {
                setAddObserver((prev) => ({
                    ...prev,
                    [fieldToUpdate]: sanitizedOption
                }));
            }
            return
        }
        if (fieldToUpdate) {
            if (fieldToUpdate === "monitor_permission") {
                setAddObserver((prev) => ({
                    ...prev,
                    "monitor_permission": !addObserver.monitor_permission,
                }));
            }
            else if (fieldToUpdate === "mobile_number" || fieldToUpdate === "main_number") {
                if (option.length <= 20) {
                    setAddObserver((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));
                }
            }
            else if (fieldToUpdate === "first_name" || fieldToUpdate === "last_name") {
                if (option.length <= 30) {
                    setAddObserver((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option,
                    }));

                }

            }
            else if (fieldToUpdate === "email_addr" || fieldToUpdate === "user_name") {
                setUsernameError(false)
                if (option.length <= 80) {
                    setAddObserver((prev) => ({
                        ...prev,
                        [fieldToUpdate]: option.replace(/\s/g, ''),
                    }));

                }
            }
            else {
                setAddObserver((prev) => ({
                    ...prev,
                    [fieldToUpdate]: option,
                }));
            }

        }

    }

    const handleSelectionPatient = (item) => {
        setIsdisableCancel(false)
        setLinkOrganizationModel(true)
        setSelectedPatient((prevState) => ({
            ...prevState,
            patient_id: item.patient_id,
            patient_first_name: item.first_name,
            patient_last_name: item.last_name,
            patient_middle_name: item.middle_name,
            patient_object_id: item?._id
        }));
        setIsOpenPatient(false)
        // this is use for refresh the subdivision value

    }

    const handleCloseDeleteModal = () => {
        setDeleteModel(false)
    }

    const handleAddAssociation = async () => {
        setIsdisableCancel(false)
        let userid = edit ? data[0]?.user_id : ''
        setdeleteLoading(true)
        let body = {
            "patient_id": selectedPatient?.patient_id,
            "patient_first_name": selectedPatient?.patient_first_name,
            "patient_middle_name": selectedPatient?.patient_middle_name,
            "patient_last_name": selectedPatient?.patient_last_name,
            "organization_id": profileDetails?.organization_id,
            "organization_name": profileDetails?.organization_name,
            "subdivision_id": selectedSubdivisionId,
            "subdivision_name": selectedSubdivisionName.subdivision_name
        }
        if (edit) {
            const response = await linkPatienttoObserver({ userid, body })
            if (response?.data?.message === "Patient associated successfully") {
                setToastmessage('Patient associated successfully')
                setLinkOrganizationModel(false)
                patientDetailsTrigger(selectedPatient?.patient_object_id)
                setdeleteLoading(false)
            } else {
                setToastErrorMessage(response?.error?.data?.message);
                setLinkOrganizationModel(false)
                setdeleteLoading(false)

            }
        } else {
            setToastmessage('Patient associated successfully')
            setLinkOrganizationModel(false)
            patientDetailsTrigger(selectedPatient?.patient_object_id)
            setdeleteLoading(false)
        }


    }
    // verfiy email address
    const handleOnVerifyEmail = async () => {


        if (addObserver?.email_addr?.trim() !== "" && validateEmail(addObserver?.email_addr?.trim())) {
            setEmailError((prev) => ({
                ...prev,
                "email_error": true
            }))

            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return

        }
        try {
            setEmailButtonLoading(true)
            let response = null
            let body = {}
            body = {
                "user_type": "observer",
                "email_address": addObserver.email_addr.trim().replace(/\s/g, ''),
            }
            const emailVerifyRes = await updateEmail({ id, body })

            if (emailVerifyRes?.error?.data?.message === "Email Address must be a valid email address") {
                setEmailError((prev) => ({
                    ...prev,
                    "email_error": true
                }))
                setEmailButtonLoading(false)
            }
            else if (emailVerifyRes?.error?.data?.message) {
                setConfirmationState(false)
                setToastErrorMessage(emailVerifyRes?.error?.data?.message)
                setEmailButtonLoading(false)
            }
            else {
                setToastmessage(emailVerifyRes?.data?.message);
                setEmailButtonLoading(false)
                setEmailVeriedButton(false)
            }
            setIsdisableCancel(true)
        } catch (error) {
            setLoading(false);
            setToastErrorMessage(error.message)
        }

    }

    const handleConfirmDelete = async () => {
        setdeleteLoading(true)

        let observer_id = edit ? data[0]?.user_id : ''
        let patient_id = selectedPatient?.patient_id
        if (edit) {
            const response = await deletePatientAssociatedObserver({ observer_id, patient_id })
            if (response?.error) {
                setToastErrorMessage(response?.error?.data?.message)
                setDeleteModel(false)
                setdeleteLoading(false)

            } else {
                setToastmessage('Patient removed successfully')
                setDeleteModel(false)
                setdeleteLoading(false)
                setSelectedPatient({
                    patient_id: '',
                    patient_object_id: '',
                    patient_first_name: '',
                    patient_middle_name: '',
                    patient_last_name: ''

                })
            }
        } else {
            setToastmessage('Patient removed successfully')
            setDeleteModel(false)
            setdeleteLoading(false)
            setSelectedPatient({
                patient_id: '',
                patient_object_id: '',
                patient_first_name: '',
                patient_middle_name: '',
                patient_last_name: ''

            })

        }


    }

    const handleOnAddObserverDetails = async () => {
        setSubmitSelected(true)
        const hasEmptyFields = () => {
            let isFieldsEmpty = false
            if (
                addObserver.user_name.trim() === "" ||
                addObserver.first_name.trim() === "" ||
                addObserver.last_name.trim() === "" ||
                addObserver.main_number.trim() === "" ||
                (edit && addObserver.email_addr.trim() === "")
            ) {
                isFieldsEmpty = true;
            }
            return isFieldsEmpty;

        };
        if (hasEmptyFields()) {

            setLoading(false)
            setEmptyField(true);
            setToastErrorMessage("Please fill in all the mandatory fields");

            return;

        }
        if (validateEmail(addObserver?.user_name?.trim())) {
            setEmailError((prev) => ({
                ...prev,
                "username_error": true
            }))


            if (addObserver?.email_addr?.trim() !== "" && validateEmail(addObserver?.email_addr?.trim())) {
                setEmailError((prev) => ({
                    ...prev,
                    "email_error": true
                }))

            }
            setLoading(false)
            // dispatch(handleIsAPICall(true))
            return
        }
        if (addObserver?.email_addr?.trim() !== "" && validateEmail(addObserver?.email_addr?.trim())) {

            setEmailError((prev) => ({
                ...prev,
                "email_error": true
            }))
            setLoading(false);
            return
        }


        if ((!(isPhoneNumberValid.main_number) && addObserver?.main_number !== '') || (!(isPhoneNumberValid.mobile_number) && addObserver?.mobile_number !== '')) {
            // Delay showing the toast message until isPhoneNumberValid is updated
            setLoading(false);
            return;
        }
        else {
            setConfirmationState(true)
        }

    }
    const handleFetchProfileDetails = async () => {
        setInitialLoader(true)
        const response = await dataService.getOrganizationUserdetails(sessionStorage.getItem('id'));
        if (response.error === false) {
            setProfileDetails(response.data.data[0])
            setInitialLoader(false)
        } else {
            setInitialLoader(false)
        }
    }
    useEffect(() => {
        handleFetchProfileDetails()
    }, [])

    const handleFinalSubmit = async () => {
        try {
            setLoading(true)
            let response = null
            let body = {

            }
            edit ? body = {
                "user_name": addObserver.user_name.trim().replace(/\s/g, ''),
                "first_name": addObserver.first_name.trim(),
                "last_name": addObserver.last_name.trim(),

                "mobile_number": addObserver.mobile_number,
                "main_number": addObserver.main_number,
                "mobile_country_code": "+" + (countryCodeVal2 !== "" ? countryCodeVal2?.split('\t').join('').trim() : country_code.split('\t').join('').trim()),
                "main_country_code": "+" + (countryCodeVal !== "" ? countryCodeVal?.split('\t').join('').trim() : country_code.split('\t').join('').trim()),
                "address": addObserver.address,
                "organization_id": profileDetails?.organization_id,
                "organization_name": profileDetails?.organization_name,
                "subdivision_id": selectedSubdivisionId,
                "subdivision_name": selectedSubdivisionName.subdivision_name,
                "sms_alert": observerSmsAlert,
                "email_alert": observerEmailAlert,
                "missed_reading_alert": observerMissedReading,
                "reading_received_alert": observerReadingReceived,

            } : body = {

                "user_name": addObserver.user_name.trim().replace(/\s/g, ''),
                "first_name": addObserver.first_name.trim(),
                "last_name": addObserver.last_name.trim(),

                "mobile_number": addObserver.mobile_number,
                "main_number": addObserver.main_number,
                "mobile_country_code": "+" + (countryCodeVal2 !== "" ? countryCodeVal2?.split('\t').join('').trim() : country_code.split('\t').join('').trim()),
                "main_country_code": "+" + (countryCodeVal !== "" ? countryCodeVal?.split('\t').join('').trim() : country_code.split('\t').join('').trim()),
                "address": addObserver.address,
                "organization_id": profileDetails?.organization_id,
                "organization_name": profileDetails?.organization_name,
                "subdivision_id": selectedSubdivisionId,
                "subdivision_name": selectedSubdivisionName.subdivision_name,
                "patient_id": selectedPatient.patient_id,
                "patient_first_name": selectedPatient.patient_first_name,
                "patient_middle_name": selectedPatient.patient_middle_name,
                "patient_last_name": selectedPatient.patient_last_name,
                "sms_alert": observerSmsAlert,
                "email_alert": observerEmailAlert,
                "missed_reading_alert": observerMissedReading,
                "reading_received_alert": observerReadingReceived,

            }
            if (edit) {
                const editRes = await editObserver({ id, body })

                //dispatch(handleIsAPICall(true))
                if (editRes?.error?.data?.message) {
                    setToastErrorMessage(editRes?.error?.data?.message)
                    setLoading(false)
                }
                else {
                    navigate(`/manage-observer/${id}`, { state: originalListingState })
                    //navigate('/manage-observer/')
                    setToastmessage('Observer details updated successfully');
                    setLoading(false)
                }
            }
            else {
                const addRes = await addObserverDetails(body)

                if (addRes?.error?.data?.message) {
                    setConfirmationState(false)
                    setToastErrorMessage(addRes?.error?.data?.message)
                    setLoading(false)
                    if (addRes?.error?.data?.message === "Username already exists. Please try another") {
                        setUsernameError(true)
                    }
                }
                else {
                    navigate(`/manage-observer/${addRes?.data?.user_id}`, { state: originalListingState })
                    //navigate(`/manage-observer`)

                    setToastmessage(addRes?.data?.message);
                    setLoading(false)
                }
            }

        } catch (error) {
            setLoading(false);
            //dispatch(handleIsAPICall(true))
            setToastErrorMessage(error.message)
        }

    }

    const handleConformationClick = (status) => {
        setEmptyArea(false)
        status === "status" && setStatusToggle(!statusToggle)
        setTextAreaMsg("")
        setConfirmationState(false)
        setConfirmationStateStatus(false);
    }
    const handleConformationClickCancel = () => {
        setEmptyArea(false)
        setConfirmationStateCancel(false);
    }

    const handleCancel = () => {
        setConfirmationStateCancel(false);
        // Clear form values
        setAddObserver({
            "user_name": "",
            "first_name": "",
            "last_name": "",
            "mobile_number": "",
            "main_number": "",
            "address": "",
            "email_addr": "",
        });
        if (nextTarget === 'view') {
            navigate(`/manage-observer/${id}`, { state: location.state });
        } else {
            navigate('/manage-observer', { state: originalListingState });
        }
    };

    const handleCancelBottom = () => {
        const stateToPass = Array.isArray(location.state) ? '' : location.state;

        if (isDisableCancel && location?.state?.fromScreen && location.state.fromScreen === 'view') {
            navigate(`/manage-observer/${id}`, { state: location.state });
        } else if (isDisableCancel) {
            navigate('/manage-observer',{state: stateToPass});
        } else {
            setNextTarget(
                location?.state?.fromScreen && location.state.fromScreen === 'view'
                    ? 'view'
                    : 'list'
            );
            setConfirmationStateCancel(true);
        }
        // const values = Object.values(addObserver);
        // const isAnyValueFilled = values?.some((value) => typeof value !== "boolean" && value?.trim() !== ""); // Check if any value is filled
        // if (isDisableCancel) {
        //     navigate('/manage-observer')
        // }
        // if (!isAnyValueFilled) {
        //     navigate('/manage-observer')
        // } else {
        //     setConfirmationStateCancel(true);
        // }
    };

    const handleCloseLinkModel = () => {
        setSelectedPatient({
            patient_id: '',
            patient_object_id: '',
            patient_first_name: '',
            patient_middle_name: '',
            patient_last_name: ''

        })
        setLinkOrganizationModel(false)
    }

    useEffect(()=>{
        if(edit){
            setSkip(false) 
        }   
        if(id){
            trigger(id)      
        }    
    },[edit])

    useEffect(() => {
        if (edit) {
            if (userType === 'admin') {
                setQueryParamsorg('type=org-edit-observer');
            } else {
                setQueryParamsorg('type=org-user-edit-observer');
            }
        } else {
            if (userType === 'admin') {
                setQueryParamsorg('type=org-add-observer');
            } else {
                setQueryParamsorg('type=org-user-add-observer');
            }
        }
    }, [userType,edit]);
      
    useEffect(() => {
        if (queryParamsorg) {
            setTriggerApiCall(true);  // Allow the query to run
        }
    }, [queryParamsorg]);

    useEffect(() => {
        if(!userIDRef.current) {
            userIDRef.current = editingUserId
        }
    }, [editingUserId])

    useEffect(()=>{
        let hasLoggedOut = false;
        if (editSocket && !hasLoggedOut) {
            
            editSocket.onmessage = async (event) => {
                if (hasLoggedOut) {
                    return; // Prevent multiple logout calls
                }else if (event.data === "logout") {
                    hasLoggedOut = true;
                    await userService.DuplicateLogout();
                    let arcm_trust_browser_token = localStorage.getItem('arcm_trust_browser_token')
                    let LogoutfromAllTabs = localStorage.getItem('LogoutfromAllTabs')
                    localStorage.clear();
                    sessionStorage.clear();
                    localStorage.setItem("arcm_trust_browser_token",arcm_trust_browser_token)
                    localStorage.setItem("LogoutfromAllTabs",LogoutfromAllTabs)
                    sessionStorage.setItem('showLogoutToast', 'true');
                    setTimeout(() => {
                        // window.location.reload();
                        setToastErrorMessage("You have been logged out due to another login session");
                        navigate('/');
                    }, 500);
                }
            };
        }
    },[editSocket])

    useEffect(() => {

        if (result!==undefined&&result?.data?.[0]?.user_id!==undefined) {
            dispatch(handleTargetUserEditId(result?.data?.[0]?.user_id))
            if(edit && !messageSent && editSocket){
               
                sendMessageToStartEditing(result?.data?.[0]?.user_id)
                let message
                editSocket.onmessage = (event) =>{
                    message = event.data
                    if(JSON.parse(message)?.success_status===true && JSON.parse(message)?.message==='Success'){
                        setDataLoading(false)
                    } else{
                        dispatch(handleEditMessageSent(false))
                        navigate('/manage-observer', { state: originalListingState })
                        { (JSON.parse(message)?.adminId) &&
                            setToastErrorMessage(`A user with username ${decodeURIComponent( JSON.parse(message)?.adminId)} is already editing this observer`)
                        }
                    }
                }    
            }else{
                setDataLoading(false)
            }
            // setMonitorUserId(data?.user_id)
            setAddObserver((prev) => ({
                ...prev,
                "user_name": result?.data[0]?.user_name,
                "first_name": result?.data[0]?.first_name,
                "last_name": result?.data[0]?.last_name,
                "email_addr": result?.data[0]?.email_address,
                "mobile_number": result?.data[0]?.mobile_number,
                "main_number": result?.data[0]?.main_number,
                "address": result?.data[0]?.address,

            }))
            setSelectedOrganizationName((prev) => ({
                ...prev,
                "organization_name": result?.data[0]?.organization_name,
                "organization_id": result?.data[0]?.organization_id
            }))
            if (data && edit) {
                setSelectedSubdivisionName((pre) => ({
                    ...pre,
                    "subdivision_name": result?.data[0].subdivision_name,
                }))
            }
            // subTrigger(`filter=true&organization_id=${result?.data[0]?.organization_id}&dropdown=true`)
            setStatusToggle(result?.data[0]?.status === "inactive" ? false : true)
            
            // Set alert preferences from API response
            if (result?.data?.[0]) {
                setObserverSmsAlert(result?.data[0]?.sms_alert || false)
                setObserverEmailAlert(result?.data[0]?.email_alert || false)
                setObserverMissedReading(result?.data[0]?.missed_reading_alert || false)
                setObserverReadingReceived(result?.data[0]?.reading_received_alert || false)
            }
            
            result?.data[0]?.subdivision_id !== undefined && setSelectedSubdivisionId(result?.data[0]?.subdivision_id)
            // result?.data[0]?.organization_id !== undefined && subTrigger(`filter=true&organization_id=${result?.data[0]?.organization_id}&dropdown=true`)
            result?.data[0]?.subdivision_id !== undefined && patientTrigger(`subdivision_id=${result?.data[0]?.subdivision_id}`)
            result?.data[0]?.patient_id !== undefined && setSelectedPatient({
                patient_id: result?.data[0]?.patient_id,
                patient_object_id: result?.data[0]?._id,
                patient_first_name: result?.data[0]?.patient_first_name,
                patient_middle_name: result?.data[0]?.patient_middle_name,
                patient_last_name: result?.data[0]?.patient_last_name

            })

            setSkip(true)
        }
        if (result?.data?.[0] && edit) {
            setCountryCodeVal(result?.data[0]?.main_country_code?.split('+')[1])
            setCountryCodeVal2(result?.data[0]?.mobile_country_code?.split('+')[1])
        }
        return(()=>{
            if((location.state===null || location.state==='')&& result?.data?.[0]?.user_id!==undefined){
                sendMessageToStopEditing(result?.data?.[0]?.user_id)
            }  
        })
    }, [result,edit,editSocket])

    useEffect(()=>{
        return(()=>{
            if(location?.state!==null||location?.state!=='' && userIDRef.current){
                sendMessageToStopEditing(userIDRef.current)
            }
        })
       
    },[userIDRef])

    const handleOnCLickActivate = async (e) => {
        // useDispatch(handleIsAPICall(true))
        if (statusToggle === false && textAreaMsg.trim() === "") {
            setToastErrorMessage('Please fill in the mandatory field')

            setEmptyArea(true)

            return;
        }
        try {
            let body = {}
            if (statusToggle === false) {
                body = {
                    "user_names": [data[0]?.user_name],
                    "status": "inactive",
                    "note": textAreaMsg
                }
            }
            else {
                body = {
                    "user_names": [data[0]?.user_name],
                    "status": "active",
                    "note": ''
                }
            }

            setLoadingStatus(true)

            const activationRes = await editObserver({ body })
            setLoadingStatus(false)

            if (activationRes?.data?.error) {
                setToastErrorMessage('Something went wrong. Please try again')
            } else {
                setToastmessage(`Observer ${statusToggle === true ? "activated" : "deactived"} successfully`);

            }
            setConfirmationStateStatus(false);
            setTextAreaMsg('');

        } catch (error) {
            setConfirmationStateStatus(false);
            setToastErrorMessage('Something went wrong. Please try again')
        }
    }

    useEffect(() => {
        const fetchData = async () => {
            try {
                const response = await dataService.GetAPI(`system-configuration/`);
                dispatch(handleSystemConfig(response.data.data))
            } catch (error) {
                console.error("Error fetching data:", error);
            } 
        };
        fetchData();
    }, []);


    return (
        <>
            <div className='bg-[#F9F3F5] pt-[95px] px-[30px] h-full w-full overflow-x-hidden'>
                <TopHeader title={"Manage Observers"} />
                {((edit && isFetching && status !== "fulfilled" )) ? <CustomOverLay Active text='Loading Observer Details...' classKey={`absolute top-0 left-0 z-50 overflowhidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened-sidebar-config' : 'system_config_overlay'}`} /> : status === "rejected" ? <SearchEmptyScreen text={"No data found"} /> : <>
                    <div className='bg-white rounded-lg pb-[12px] pt-3.5 pl-6 pr-[10px] h-customh3'>
                        <motion.div
                            className="mt-1"
                            animate={{ x: 0 }}
                            initial={{ x: -10 }}
                            transition={{ duration: 0.5 }}
                        >
                            <div className='bg-white'>
                                <div className='pr-6'>
                                    <div className='flex items-center mb-5'>
                                        <Link to="/manage-observer" state={Array.isArray(location.state) ? '' : location.state}>
                                            <h1 className="text-sm font-normal text-[#52555D]">List of Observers</h1>
                                        </Link>
                                        <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                        {(location?.state?.fromScreen && location?.state?.fromScreen === 'view') ?
                                            <>
                                                <Link to={`/manage-observer/${id}`} state={Array.isArray(location.state) ? '' : location.state}  >
                                                    <h1 className="text-sm font-normal  text-[#52555D]">{`View Observer`}</h1>
                                                </Link>
                                                <span className='mx-2'><img src="/images/breadcrumb-icon.svg" alt="icon" /></span>
                                                <h1 className="text-sm font-normal  text-[#008586]">{`Edit Observer`}</h1>
                                            </>
                                            :
                                            <h1 className="text-sm font-normal text-[#008586]">{edit ? "Edit" : "Add"} Observer</h1>
                                        }
                                        <span   onClick={() => setHelpGuideModel(true)} className=' ml-auto cursor-pointer'>
                                            <img src="/images/helpguideicon.png" alt="icon" loading="lazy" decoding="async" />
                                        </span> 
                                    </div>
                                    {(location?.state?.fromScreen && location?.state?.fromScreen === 'view') ?

                                        <div onClick={handleCancelBottom} state={Array.isArray(location.state) ? '' : location.state} className='items-center cursor-pointer min-w-max flex'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] pl-3'>Go back to View Observer</span>
                                        </div>
                                        :
                                        <div onClick={handleCancelBottom} className='flex cursor-pointer items-center'>
                                            <span><img src="/images/back_button_Green.svg" alt="icon" /></span>
                                            <span className='text-sm font-normal text-[#008586] ml-3'>Go back to Listing</span>
                                        </div>
                                    }

                                    <h1 className='text-xl font-normal text-[#000000] w-full text-center mt-[-23px]'>
                                        {`${edit ? 'Edit ' : 'Add '} Observer`}
                                    </h1>
                                    <p className='text-end pt-3.5 pb-1'>‘*’ Indicates mandatory field</p>
                                </div>
                                <div className={`pr-5 h-customh18 overflow-auto overflow-x-hidden scrollbar_purple bg-white`}>
                                    <div className="border border-[#C5C9DA] rounded-lg px-6 2xl:px-[57px] py-6 mb-4">
                                        <div className='flex flex-wrap -mx-3'>
                                            {edit && <div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Username*"}
                                                        placeholder={"Enter username"}
                                                        id={"user_name"}
                                                        htmlFor={"Admin_Username"}
                                                        value={addObserver?.user_name}
                                                        emailError={emailError.username_error}
                                                        usernameError={usernameError}
                                                        emptyField={emptyField && addObserver?.user_name?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        disabled={true}
                                                    />
                                                    {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '} message={"Invalid user name"} />}
                                                </div>
                                            </div>}
                                            {edit && <div className={`w-2/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <p className="text-xs font-semibold text-[#000] mb-1.5">Enable Active Alerts</p>
                                                    <div className='flex flex-wrap gap-x-8 gap-y-2'>
                                                        {/* Alerts by SMS Toggle */}
                                                        <div className="status custom-toggle flex items-center">
                                                            <label className="switch" style={{marginRight: '10px'}}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={()=>{
                                                                        setObserverSmsAlert(!observerSmsAlert)
                                                                        setIsdisableCancel(false)
                                                                    }}
                                                                    checked={observerSmsAlert}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal text-[#000000]">Alerts by SMS</p>
                                                        </div>
                                                        
                                                        {/* Alerts by Email Toggle */}
                                                        <div className="status custom-toggle flex items-center">
                                                            <label className="switch" style={{marginRight: '10px'}}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={()=>{
                                                                        setObserverEmailAlert(!observerEmailAlert)
                                                                        setIsdisableCancel(false)
                                                                    }}
                                                                    checked={observerEmailAlert}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal text-[#000000]">Alerts by Email</p>
                                                        </div>
                                                        
                                                        {/* Include Missed Readings Toggle */}
                                                        <div className="status custom-toggle flex items-center">
                                                            <label className="switch" style={{marginRight: '10px'}}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={()=>{
                                                                        setObserverMissedReading(!observerMissedReading)
                                                                        setIsdisableCancel(false)
                                                                    }}
                                                                    checked={observerMissedReading}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal text-[#000000]">Include Missed Readings</p>
                                                        </div>
                                                        
                                                        {/* Receive readings acknowledgement Toggle */}
                                                        <div className="status custom-toggle flex items-center">
                                                            <label className="switch" style={{marginRight: '10px'}}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={()=>{
                                                                        setObserverReadingReceived(!observerReadingReceived)
                                                                        setIsdisableCancel(false)
                                                                    }}
                                                                    checked={observerReadingReceived}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal text-[#000000]">Receive readings acknowledgement</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            {!edit && <div className={`w-1/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Username*"}
                                                        placeholder={"Enter username"}
                                                        id={"user_name"}
                                                        htmlFor={"Admin_Username"}
                                                        value={addObserver?.user_name}
                                                        emailError={emailError.username_error}
                                                        usernameError={usernameError}
                                                        emptyField={emptyField && addObserver?.user_name?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}

                                                    />
                                                    {emailError.username_error && <ErrorMessage error classKey={'text-sm font-normal text-[#F04438] mt-2 '} message={"Invalid user name"} />}
                                                </div>
                                            </div>}
                                            {!edit && <div className={`w-2/3 px-3 mb-[22px]`}>
                                                <div className='w-full'>
                                                    <p className="text-xs font-semibold text-[#000] mb-1.5">Enable Active Alerts</p>
                                                    <div className='flex flex-wrap gap-x-8 gap-y-2'>
                                                        {/* Alerts by SMS Toggle */}
                                                        <div className="status custom-toggle flex items-center">
                                                            <label className="switch" style={{marginRight: '10px'}}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={()=>{
                                                                        setObserverSmsAlert(!observerSmsAlert)
                                                                        setIsdisableCancel(false)
                                                                    }}
                                                                    checked={observerSmsAlert}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal text-[#000000]">Alerts by SMS</p>
                                                        </div>
                                                        
                                                        {/* Alerts by Email Toggle */}
                                                        <div className="status custom-toggle flex items-center">
                                                            <label className="switch" style={{marginRight: '10px'}}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={()=>{
                                                                        setObserverEmailAlert(!observerEmailAlert)
                                                                        setIsdisableCancel(false)
                                                                    }}
                                                                    checked={observerEmailAlert}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal text-[#000000]">Alerts by Email</p>
                                                        </div>
                                                        
                                                        {/* Include Missed Readings Toggle */}
                                                        <div className="status custom-toggle flex items-center">
                                                            <label className="switch" style={{marginRight: '10px'}}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={()=>{
                                                                        setObserverMissedReading(!observerMissedReading)
                                                                        setIsdisableCancel(false)
                                                                    }}
                                                                    checked={observerMissedReading}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal text-[#000000]">Include Missed Readings</p>
                                                        </div>
                                                        
                                                        {/* Receive readings acknowledgement Toggle */}
                                                        <div className="status custom-toggle flex items-center">
                                                            <label className="switch" style={{marginRight: '10px'}}>
                                                                <input
                                                                    type="checkbox"
                                                                    onChange={()=>{
                                                                        setObserverReadingReceived(!observerReadingReceived)
                                                                        setIsdisableCancel(false)
                                                                    }}
                                                                    checked={observerReadingReceived}
                                                                />
                                                                <span className="slider round"></span>
                                                            </label>
                                                            <p className="text-sm font-normal text-[#000000]">Receive readings acknowledgement</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>}
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"First Name*"}
                                                        placeholder={"Enter first name"}
                                                        id={"first_name"}
                                                        htmlFor={"Admin_First_Name"}
                                                        value={addObserver?.first_name}
                                                        emptyField={emptyField && addObserver?.first_name?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <InputBox
                                                        label={"Last Name*"}
                                                        placeholder={"Enter last name"}
                                                        id={"last_name"}
                                                        htmlFor={"Admin_Last_Name"}
                                                        value={addObserver?.last_name}
                                                        emptyField={emptyField && addObserver?.last_name?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                    />
                                                </div>
                                            </div>
                                            {!edit &&
                                                <div className={`w-1/3 px-[18px] mb-[35px]`}>
                                                    <div className='w-full'>
                                                        <InputBox
                                                            label={"Email Address*"}
                                                            placeholder={"Enter email address"}
                                                            id={"email_addr"}
                                                            htmlFor={"email_addr"}
                                                            value={addObserver?.user_name}
                                                            disabled={true}
                                                            emptyField={false}
                                                            emailError={emailError.email_error}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                        {emailError.email_error && <ErrorMessage error message={"Invalid email address"} />}
                                                    </div>
                                                </div>
                                            }

                                            {
                                                edit && <><div className={` w-full flex px-3 mb-[22px]`}>
                                                    <div className={'w-1/3'}>
                                                        <InputBox
                                                            label={"Email Address*"}
                                                            placeholder={"Enter email address"}
                                                            id={"email_addr"}
                                                            htmlFor={"email_addr"}
                                                            value={addObserver?.email_addr}
                                                            emptyField={emptyField && addObserver?.email_addr?.trim() === ""}
                                                            emailError={emailError.email_error}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                        {emailError.email_error && <ErrorMessage error message={"Invalid email address"} />}
                                                    </div>

                                                    {
                                                        edit && (<>
                                                            {(Array.isArray(data) && data.length > 0) && (data[0].email_address !== addObserver?.email_addr) && (
                                                                <div className={`w-2/3 px-[18px] mb-[35px] pt-3.5`}>
                                                                    <button
                                                                        type='button'
                                                                        id="verify"
                                                                        onClick={() => handleOnVerifyEmail()}
                                                                        disabled={emailButtonLoading || addObserver?.email_addr?.trim() === ""}
                                                                        className={`px-4 py-2 text-lg flex items-center justify-center font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[170px]
                        bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88] disabled:cursor-not-allowed`}
                                                                    >
                                                                        {!emailButtonLoading ? "Verify" : <span>{<Loader />}</span>}
                                                                    </button>
                                                                </div>
                                                            )}

                                                            {(Array.isArray(data) && data.length > 0) && (data[0].email_address === addObserver?.email_addr) &&
                                                                <div className={`w-2/3 px-[18px] mb-[35px] pt-3`}>
                                                                    <button type='button'
                                                                        id="verified"
                                                                        className={`px-4 py-2 flex items-center justify-center text-lg font-semibold text-[#000] rounded-[16px] mt-2.5 w-[170px] cursor-default
                                                            bg-[#C5C9DA] disabled:bg-[#777C88] disabled:cursor-not-allowed`}>
                                                                        <span className='w-6 h-6 bg-[#1A883C] rounded-[50%] mr-2.5 flex justify-center items-center'>
                                                                            <img src="/images/success_toast.svg" alt="icon" loading='lazy' className='w-3.5 h-3.5' decoding='async' />
                                                                        </span>
                                                                        Verified
                                                                    </button>
                                                                </div>
                                                            }
                                                        </>)


                                                    }


                                                </div></>
                                            }

                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <PhoneNumberValidator
                                                        label={"Mobile Number"}
                                                        placeholder={"Enter mobile number"}
                                                        id={"mobile_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={addObserver?.mobile_number}
                                                        emptyField={false}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        isCode={true}
                                                        countryCodeList={countryCodes}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal2}
                                                        isPhoneNumberValid={isPhoneNumberValid?.mobile_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        setCountryCodeVal={setCountryCodeVal2}
                                                        submitSelected={submitSelected}
                                                    />
                                                </div>
                                            </div>
                                            <div className='w-1/3 px-3 mb-[22px]'>
                                                <div className='w-full'>
                                                    <PhoneNumberValidator
                                                        label={"Main Number*"}
                                                        placeholder={"Enter main number"}
                                                        id={"main_number"}
                                                        htmlFor={"Admin_Mobile_Number"}
                                                        value={addObserver?.main_number}
                                                        emptyField={emptyField && addObserver?.main_number?.trim() === ""}
                                                        handleOnChangeInput={handleOnChangeUserDetails}
                                                        isCode={true}
                                                        countryCodeList={countryCodes}
                                                        country_code={country_code}
                                                        countryCodeVal={countryCodeVal}
                                                        setCountryCodeVal={setCountryCodeVal}
                                                        isPhoneNumberValid={isPhoneNumberValid?.main_number}
                                                        setIsPhoneNumberValid={setIsPhoneNumberValid}
                                                        submitSelected={submitSelected}
                                                    />
                                                </div>
                                            </div>
                                            {edit && <div className='w-1/3 px-[18px]'>
                                                <div className='w-full mt-10 '>
                                                    <div className="status custom-toggle flex items-center ">
                                                        <p className="text-sm font-normal  text-[#000000] disable_switch  mr-4">
                                                            Status
                                                        </p>
                                                        <label className="switch" style={{ marginLeft: '10px' }}>
                                                            <input type="checkbox" id="user_status" onChange={(e) => {
                                                                setStatusToggle(!statusToggle), setConfirmationStateStatus(true)
                                                            }} checked={statusToggle} /><span className="slider round"></span>
                                                        </label>
                                                        <p className="text-sm font-normal  text-[#008586] disable_switch ml-3">
                                                            {statusToggle ? 'Active' : 'Inactive'}
                                                        </p>
                                                    </div>
                                                </div>
                                            </div>}
                                            <div className='w-full'>
                                                <div className='w-2/3 px-3'>
                                                    <div className='w-full mb-6 h-[120px]'>
                                                        <TextArea label={'Address'}
                                                            htmlFor={'user_address'}
                                                            id={'address'}
                                                            value={addObserver?.address}
                                                            placeholder={'Enter Address'}
                                                            // emptyField={false}
                                                            handleOnChangeInput={handleOnChangeUserDetails}
                                                        />
                                                    </div>
                                                </div>

                                            </div>

                                            <div className='xl:w-1/3 w-1/2 px-[18px]'>
                                                <div className='flex'>
                                                    <div className='w-full mr-2'>
                                                        <SubdivisionDropdownWithSearch
                                                            label={"Sub Division Name"}
                                                            placeholder={'Select sub division name'}
                                                            id={'sub_division_name'}
                                                            subdivisionData={suddivisonData}
                                                            disabled={(addObserver !== undefined && selectedPatient?.patient_id !== '' && linkOrganizationModel !== true) ? true : false}
                                                            selectedSubdivisionName={selectedSubdivisionName}
                                                            setisOpensub={setisOpensub}
                                                            setQueryParams={setQueryParams}
                                                            isOpensub={isOpensub}
                                                            handleSelectionSubdivision={handleSelectionSubdivision}
                                                            setSelectedOrganizationName={''}
                                                            subdivisionloadingstatus={subdivisionStatus}
                                                            isMonitor={true}
                                                            emptyField={false}
                                                        />

                                                    </div>
                                                </div>
                                            </div>

                                        </div>

                                        {<div className='flex flex-col gap-3'>
                                            <p className='pt-[48px] min-w-fit text-base font-semibold text-[#972E4C] relative '>
                                                Patient List
                                            </p>
                                            <div className='mr-10'>
                                                <div className='flex flex-row lg:gap-16 gap-6 xl:gap-10  w-full justify-between'>
                                                    <div className={"xl:w-[60%] w-1/2"}>
                                                        <PatientDropdownWithSearch
                                                            organizationListSearch={patientListSearch}
                                                            setSearchParams={setSearchParams}
                                                            id={`patient_name`}
                                                            placeholder={'Select patient'}
                                                            disabled={selectedSubdivisionId === '' || (selectedPatient?.patient_id !== '')}
                                                            value={patientListSearch.search || ''}
                                                            organizationData={patientRes?.data}
                                                            organizationFetching={patientRes?.isFetching}
                                                            handleOrganizationListSearch={handlePatientListSearch}
                                                            handleFetchSubdivision={handleSelectionPatient}
                                                            selectedOrganizationName={selectedPatient}
                                                            setisOpen={setIsOpenPatient}
                                                            isOpen={isOpenPatient}
                                                            linkOrganizationModel={linkOrganizationModel}
                                                            optionId={"option_organization_name"}
                                                            isMonitor={false}
                                                        />
                                                    </div>
                                                    {selectedPatient?.patient_id !== '' && linkOrganizationModel !== true && <div className='xl:w-[40%] flex justify-end'>
                                                        <button type='button'
                                                            id={'link_patient'}
                                                            className={`py-2 xl:px-[60px] lg:px-8 px-5 self-end min-w-max flex items-center text-lg font-normal border border-[#972E4C] text-[#972E4C] rounded-[16px] ml-2.5   bg-[#fff]`}
                                                            onClick={() => { setDeleteModel(true) }}
                                                        >
                                                            <span className="mr-2.5 text-center"><img src="/images/Dowd_dark.png" alt="img" /></span>
                                                            Remove Patient
                                                        </button>
                                                    </div>}
                                                </div>
                                            </div>

                                            {(patientDetailsRes?.status !== 'uninitialized' && (patientDetailsRes?.isFetching && patientDetailsRes?.status !== "fulfilled" && patientDetailsRes?.status !== "rejected")) ? <CustomOverLay Active text="Loading patient details..." classKey={` top-0 left-0 right-0  z-50 overflow-hidden bg-gray-400 opacity-75 flex flex-col items-center justify-center ${isSideBar ? 'opened_sidebar_patient' : 'overlay-patient'}`} /> : selectedPatient?.patient_id !== '' && linkOrganizationModel !== true ? <div className='border border-[#EDD7E1] rounded-lg flex flex-col p-4 mr-10 mt-3'>
                                                <div className='flex xl:gap-[60px] gap-[10px]'>
                                                    <div>
                                                        <div>
                                                            <p className='mb-2'>Patient ID</p>
                                                            <p className='mb-6 text-[#031624]'>{patientDetailsRes?.data === undefined ? data[0]?.patient_id : patientDetailsRes?.data[0]?.patient_id}</p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'>First Name</p>
                                                            <p className='mb-6 text-[#031624]' style={{ lineBreak: "anywhere" }}>{patientDetailsRes?.data === undefined ? data[0]?.patient_first_name : patientDetailsRes?.data[0]?.first_name}</p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'>Date of Birth</p>
                                                            <p className='mb-6 text-[#031624]'>{patientDetailsRes?.data === undefined ? data[0]?.patient_date_of_birth : patientDetailsRes?.data[0]?.date_of_birth}</p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'>Primary Identifier</p>
                                                            <p className='mb-6 text-[#031624]'>{patientDetailsRes?.data === undefined ? data[0]?.patient_primary_identifier : patientDetailsRes?.data[0]?.primary_identifier}</p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'>Email Address</p>
                                                            <p className='mb-6 text-[#031624]'>{patientDetailsRes?.data === undefined ? data[0]?.patient_email_address : patientDetailsRes?.data[0]?.email_address}</p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            <p className='mb-2'>Username</p>
                                                            <p className='mb-6 text-[#031624]'>{patientDetailsRes?.data === undefined ? data[0]?.patient_user_name : patientDetailsRes?.data[0]?.user_name}</p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'>Middle Name</p>
                                                            <p className='mb-6 text-[#031624]' style={{ lineBreak: "anywhere" }}>{((patientDetailsRes?.data?.[0]?.middle_name === "" || patientDetailsRes?.data?.[0]?.middle_name === undefined) && (data?.[0]?.patient_middle_name === undefined || data?.[0]?.patient_middle_name === '')) ? "-" : patientDetailsRes?.data !== undefined ? patientDetailsRes?.data[0]?.middle_name : data[0]?.patient_middle_name}</p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'>Age</p>
                                                            <p className='mb-6 text-[#031624]'>{patientDetailsRes?.data === undefined ? data[0]?.patient_age : patientDetailsRes?.data[0]?.age}</p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'>Secondary Identifier</p>
                                                            <p className='mb-6 text-[#031624]'>{((patientDetailsRes?.data?.[0]?.secondary_identifier === "" || patientDetailsRes?.data?.[0]?.secondary_identifier === undefined) && (data?.[0]?.patient_secondary_identifier === undefined || data?.[0]?.patient_secondary_identifier === '')) ? "-" : patientDetailsRes?.data !== undefined ? patientDetailsRes?.data[0]?.secondary_identifier : data[0]?.patient_secondary_identifier}</p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'></p>
                                                            <p className='mb-6'></p>
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <div>
                                                            <p className='mb-2'></p>
                                                            <p className='mb-[80px]'></p>
                                                        </div>
                                                        <div>
                                                            <p className='mb-2'>Last Name</p>
                                                            <p className='mb-6 text-[#031624]' style={{ lineBreak: "anywhere" }}>{patientDetailsRes?.data === undefined ? data[0]?.patient_last_name : patientDetailsRes?.data[0]?.last_name}</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div> : (selectedPatient.patient_id === '' || linkOrganizationModel === true) && <Emptyscreenwithouttitle classKey={true} FirstPTag={"No patient selected. To view, please select the patient"} />}
                                        </div>}
                                    </div>
                                </div>
                            </div>
                            <div className='flex justify-end pr-5'>
                                <button
                                    type="button"
                                    id="cancel"
                                    onClick={() => handleCancelBottom()}
                                    className={`px-4 py-2.5 text-lg font-semibold text-[#972E4C] rounded-[16px] mt-2.5 w-[148px]
        border border-[#972E4C] `}

                                >
                                    Cancel
                                </button>
                                <button type='button'
                                    id="update"
                                    data-testid="updateobserver"
                                    onClick={handleOnAddObserverDetails}
                                    className={`px-4 py-2.5 text-lg font-semibold text-[#fff] rounded-[16px] mt-2.5 w-[148px] ml-4
                                bg-[#972E4C] hover:bg-[#AB556E] focus:bg-[#863B50] disabled:bg-[#777C88]`}>
                                    {edit ? 'Update' : 'Submit'}
                                </button>
                            </div>

                        </motion.div>
                    </div>
                </>}
                {confirmationState &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={""}
                                handleOnCLickActivate={handleFinalSubmit}
                                handleClose={handleConformationClick}
                                tittle={`${edit ? 'Update' : 'Add'} Observer`}
                                message={`Are you sure you want to ${edit ? 'update' : 'add'}  this observer?`}
                                textMessage={true === false ? false : true}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                                disabled={loading}
                            />
                        }
                    />
                }
                {confirmationStateCancel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                handleOnCLickActivate={handleCancel}
                                handleClose={handleConformationClickCancel}
                                tittle={'Cancel'}
                                message={`Are you sure you want to cancel the changes?`}
                                textMessage={true === false ? false : true}
                                disabled={loading}
                                buttonName={true && !loading ? "Yes" : <span>{<Loader />}</span>}
                                CancelButton={'No'}
                            />
                        }
                    />
                }
                {deleteModel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleConfirmDelete}
                                handleClose={handleCloseDeleteModal}
                                tittle={'Remove'}
                                message={`Are you sure you want to remove the patient?`}
                                buttonName={"Confirm"}
                                loadingActivation={deleteLoading}
                                // CancelButton={"No"}
                                disabled={deleteLoading}
                            />
                        }
                    />}
                {linkOrganizationModel &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                handleOnCLickActivate={handleAddAssociation}
                                handleClose={handleCloseLinkModel}
                                tittle={'Associate Patient'}
                                message={`Are you sure you want to associate the patient?`}
                                buttonName={"Yes"}
                                loadingActivation={deleteLoading}
                                CancelButton={"No"}
                                disabled={deleteLoading}
                            />
                        }
                    />}
                {confirmationStateStatus &&
                    <AnimatedModel
                        Children={
                            <ConfirmationPrompt
                                emptyField={emptyArea}
                                setEmptyField={setEmptyArea}
                                setTextAreaMsg={setTextAreaMsg}
                                textAreaMsg={textAreaMsg}
                                loadingActivation={loadingStatus}
                                disabled={loadingStatus}
                                handleOnCLickActivate={handleOnCLickActivate}
                                handleClose={() => { handleConformationClick("status") }}
                                tittle={statusToggle ? 'Activate' : 'Deactivate'}
                                message={`Are you sure you want to ${statusToggle ? 'activate' : 'deactivate'} the observer?`}
                                textMessage={statusToggle === false ? false : true}
                                buttonName={statusToggle ? 'Activate' : 'Deactivate'}
                            />
                        }
                    />
                }
                {(helpGuideModel && helpguidestatus==="fulfilled") &&
                <HelpGuideModal
                    setHelpGuideModel={setHelpGuideModel}
                    pdfUrl={helpguidedata} // Pass the PDF URL to the modal
                />
                }
            </div>
        </>
    )
}
